import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type { IApiGetAppUsersResponseBody } from '../AppsApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseAppUsersQueryValues = {
  appId: string;
};

export const appUsersQueryKeyFactory: IQueryKeyFactory<
  IUseAppUsersQueryValues
> = (values) => values && (['appUsers', values.appId] as const);

export const useAppUsersQuery = (
  values?: IUseAppUsersQueryValues,
  options?: UseQueryOptions<IApiGetAppUsersResponseBody, ApiError>,
): UseQueryResult<IApiGetAppUsersResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: appUsersQueryKeyFactory(values),
    queryFn: values ? () => api.apps.getUsers(values.appId) : undefined,
    ...options,
  });
};
